export { default } from './OrDivider'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/OrDivider/index.js